import { Section, AboutStyled } from "./styles"


export default function About(props) {
  return (
    <Section id="about">
      <AboutStyled>

        <h2>Quem sou eu?</h2>
        <h3>Um desenvolvedor apaixonado e estudante
          universitário de Análise e Desenvolvimento de Sistemas</h3>
        <p>Sou um desenvolvedor de software com experiência em projetos pessoais como esse. Iniciei minha jornada no desenvolvimento
          em janeiro de 2022 e desde então me tornei um entusiasta por novas
          tecnologias do mercado, buscando aprender e evoluir a cada dia.
          Atualmente, estou cursando Análise e Desenvolvimento de Sistemas na Unopar e
          focando meus estudos em PHP, Laravel e MySQL.</p>
        <p>Me considero ágil e consistente no aprendizado de novas
          tecnologias, além de ter uma alta adaptabilidade às mudanças.
          Estou sempre pronto para superar qualquer desafio!
          Se eu pudesse me definir em três palavras, certamente seriam:
          otimista, perseverante e esforçado! :)</p>

      </AboutStyled>

      <AboutStyled>
        <div>
          <h2>Informação pessoal</h2>
          <p>Aniversário : 13/10/1998</p>
          <a
            href="mailto:wellingtoneduardo16@outlook.com"
            target="_blank"
            rel="noreferrer"
          >
            <p>
              Email : <span> wellingtoneduardo16@outlook.com</span>
            </p>
          </a>
          <a href="https://wa.me/32984527181" target="_blank" rel="noreferrer">
            <p>
              Telefone :<span> +55 (32) 98452-7181</span>
            </p>
          </a>
          <p>Discord : Wellington Eduardo#5274</p>
          <p>Local : São João Del Rei / MG</p>
        </div>
      </AboutStyled>
    </Section>
  );
}
